import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import ReactQuill from 'react-quill';

const VisitSummarymodal = ({ ismodal, setIsModal, imagingdata }) => {
  if (!ismodal || !imagingdata) return null;

  const styles = `
    table { width: 100%; border-collapse: collapse; margin-top: 16px; }
    th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
    th { background-color: #f4f4f4; }
    tr:nth-child(even) { background-color: #fafafa; }
 
   
  `;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      {/* Close button */}
      <div className="relative bg-white p-6 rounded-xl shadow-2xl w-full max-w-2xl overflow-y-auto max-h-[80vh] animate-fade-in custom-scrollbar">
        <button onClick={() => setIsModal(false)} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800">
          <RxCross2 size={28} />
        </button>

        <h2 className="text-xl font-semibold text-gray-800 mb-6 text-start">Summary Details</h2>
        <style>{styles}</style>
        {/* Render Imaging Data using dangerouslySetInnerHTML */}
        {/* <div dangerouslySetInnerHTML={{ __html: imagingdata }} /> */}
          <ReactQuill
            className="w-full text-start flex-grow custom-scrollbar p-2 font-inter"
            style={{
              borderRadius: "8px",
              border: "1px solid #A2C6FD",
              background: "#FFF",
              boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
              minHeight: "200px",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              overflow:"hidden"
            }}
            value={imagingdata}
            readOnly={true}
      
            modules={{
              toolbar: [
                [{ font: [] }],
                [{ size: ["small", false, "large", "huge"] }],
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ script: "sub" }, { script: "super" }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ align: [] }],
                ["blockquote", "code-block"],
                // ["link", "image", "video"],
                ["clean"],
              ],
            }}
            formats={[
              "font", "size", "header",
              "bold", "italic", "underline", "strike",
              "color", "background",
              "script", "sub", "super",
              "list", "bullet", "indent",
              "align", "blockquote", "code-block",
              // "link", "image", "video"
            ]}
          />
      </div>
    </div>
  );
};

export default VisitSummarymodal;
